// Sanity Client Configuration
import { createClient } from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const sanityClient = createClient({
    projectId: '8qpnrka8',
    dataset: 'production',
    useCdn: true, // `false` if you want to ensure fresh data
    apiVersion: '2024-01-25', // use current date (YYYY-MM-DD) to target the latest API version
})

const builder = imageUrlBuilder(sanityClient)

export const urlFor = (source) => {
    return builder.image(source)
}

export default sanityClient


